document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('#testimonial_slider')) {

    var bannerSlider = new Splide('#testimonial_slider', {
      type: 'loop',
      drag: 'free',
      snap: true,
      arrows: true,
      pagination: false,
      breakpoints: {
        600: {
          arrows: false,
          pagination: false
        }
      },
    }).mount();
  }
});